import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/base-api.service';
import { ApiResponse } from '../../api-response';
import { DeviceSnapshot, DeviceSnapshotDownloadResponse } from '../models/device-snapshot.model';

@Injectable({ providedIn: 'root' })
export class DeviceSnapshotsService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly snapshotsUrl = `${this.coreApiUrl}/api/v1/device-snapshots`;

  requestSnapshot(deviceId: number, quality?: number): Observable<ApiResponse<DeviceSnapshot>> {
    const body: { deviceId: number; quality?: number } = { deviceId };
    if (quality != null) {
      body.quality = quality;
    }
    return this.http.post<ApiResponse<DeviceSnapshot>>(this.snapshotsUrl, body);
  }

  list(deviceId: number, page = 0, size = 20, from?: string, to?: string): Observable<ApiResponse<DeviceSnapshot[]>> {
    let params = new HttpParams()
      .set('deviceId', deviceId)
      .set('page', page)
      .set('size', size);
    if (from) {
      params = params.set('from', from);
    }
    if (to) {
      params = params.set('to', to);
    }
    return this.http.get<ApiResponse<DeviceSnapshot[]>>(this.snapshotsUrl, { params });
  }

  get(id: string): Observable<ApiResponse<DeviceSnapshot>> {
    return this.http.get<ApiResponse<DeviceSnapshot>>(`${this.snapshotsUrl}/${id}`);
  }

  getLatest(deviceId: number): Observable<ApiResponse<DeviceSnapshot>> {
    const params = new HttpParams().set('deviceId', deviceId);
    return this.http.get<ApiResponse<DeviceSnapshot>>(`${this.snapshotsUrl}/latest`, { params });
  }

  getDownloadUrl(id: string): Observable<DeviceSnapshotDownloadResponse> {
    return this.http.get<DeviceSnapshotDownloadResponse>(`${this.snapshotsUrl}/${id}/download`);
  }
}
